import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Title from "components/Reusables/Title";
import Text from "./Text";
import { colors } from "utils/styles";
import { parseDate } from "utils/helpers";
import GeneralRichText from "components/Reusables/GeneralRichText";
import ButtonGroup from "./ButtonGroup";
import MarkdownContent from "components/Reusables/MarkdownContent";
import { ContenfulQuickLink } from "components/DebugTools";

export default function RenderPressReleaseList(props) {
	const { data } = props;

	return (
		<Container>
			{data?.productCollection?.items?.map((pressRelease, count) => {
				const releaseDate = parseDate(pressRelease.releaseDate);

				return (
					//Press Release Item
					<Row className="mb-3 relative">
						<Col className="p-4">
							<Title
								className="mb-0"
								element={"h3"}
								lineHeight="30"
								text={pressRelease.title}
								color={colors.darkBlue}
							/>
							<Text
								className="mb-3"
								marginBottom="0"
								size="14px"
								color={colors["lightBrown"]}
								text={`${releaseDate.fullMonthName} ${releaseDate.dayOfMonth}, ${releaseDate.year}`}
							/>
							{/* <GeneralRichText content={pressRelease.shortDescription} /> */}
							<MarkdownContent markdown={pressRelease.shortDescription} />

							<ButtonGroup
								buttonWidth={{ xs: "4" }}
								alignButtons={"start"}
								btn1={{
									// renderAsLinkBtn1: true,
									text: "READ MORE",
									url: `/about/press-room/${pressRelease.slug}`,
								}}
							/>
						</Col>
						{process.env.APP_ENV !== "production" && (
							<ContenfulQuickLink
								title="Press Release Link"
								position="absolute"
								width="15"
								entryId={pressRelease.sys.id}
							/>
						)}

						{count < data?.productCollection?.items.length - 1 && <hr />}
					</Row>
				);
			})}
		</Container>
	);
}
